import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/industries/cpg-fmcg/components/FMCGDashboardsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/industries/cpg-fmcg/components/FMCGFinancialImpactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/industries/cpg-fmcg/components/FMCGHeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Header.tsx");
